import { useState } from 'react';

import BranchPicker from '@/shared/dev/components/BranchPicker';
import type { Option } from '@/shared/dev/types/types';

import Cookies from 'js-cookie';

type Props = {
  label: string;
  onBranchChanged: () => void;
};

const ProjectID = 262;
const EnvironmentIDs = [45];
const CookieName = 'branch';

export default function AppBranches({ label, onBranchChanged }: Props) {
  // @ts-ignore
  const [currentBranch, setCurrentBranch] = useState<string>(Cookies.get(CookieName, { domain: CONFIG.COOKIE_DOMAIN }));

  const changeBranch = (branch: Option) => {
    if (branch === null) {
      Cookies.remove(CookieName, { domain: CONFIG.COOKIE_DOMAIN });
      setCurrentBranch('<Default>');
      onBranchChanged();
    }

    if (!branch) {
      return;
    }

    Cookies.set(CookieName, branch.value, { domain: CONFIG.COOKIE_DOMAIN });
    setCurrentBranch(branch.value);
    onBranchChanged();
  };

  return (
    <BranchPicker
      label={label}
      projectId={ProjectID}
      environmentIds={EnvironmentIDs}
      currentBranch={currentBranch}
      changeBranch={changeBranch}
      replaceSlashes={true}
      branchLink={
        <a
          href={encodeURI(`https://appx.wheniwork.net/cmd/choose?serverBranch=${currentBranch}&redirect=/`)}
          className="mb-1"
        >
          Link to branch
        </a>
      }
    />
  );
}
